import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CookieConsent.css';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('shopsaverz_cookie_consent');
    if (!consent) {
      // Delay showing the banner for a premium entrance
      const timer = setTimeout(() => {
        setShowBanner(true);
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('shopsaverz_cookie_consent', 'accepted');
    setShowBanner(false);
  };

  const handleDecline = () => {
    // For DPDP compliance, we can still allow them to browse but maybe limit non-essential cookies
    localStorage.setItem('shopsaverz_cookie_consent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-consent-banner">
      <div className="cookie-content">
        <h4 className="cookie-title">🍪 Cookie & Privacy Notice</h4>
        <p className="cookie-description">
          We use cookies and similar technologies to enhance your shopping experience, 
          analyze site usage, and support our marketing efforts in compliance with 
          India's <strong>DPDP Act 2023</strong>. By clicking "Accept All", you agree 
          to our use of cookies. Learn more in our 
          <Link to="/privacy-policy" className="cookie-privacy-link" onClick={() => setShowBanner(false)}> Privacy Policy</Link>.
        </p>
      </div>
      <div className="cookie-actions">
        {/* <button className="cookie-btn-secondary" onClick={handleDecline}>
          Manage
        </button> */}
        <button className="cookie-btn-primary" onClick={handleAccept}>
          Accept All
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
